var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelineInpatientIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_1077)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#8D7DFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11.2727C10 9.46525 11.4653 8 13.2727 8H22.7273C24.5347 8 26 9.46525 26 11.2727V26.3636C26 27.2674 25.2674 28 24.3636 28H11.6364C10.7326 28 10 27.2674 10 26.3636V11.2727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 25C15 23.3431 16.3431 22 18 22C19.6569 22 21 23.3431 21 25V28H15V25Z",
    fill: "#D1D3D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4163 11.8052C19.4163 11.3605 19.0558 11 18.6111 11H17.3889C16.9442 11 16.5837 11.3605 16.5837 11.8052V13.5837L14.8052 13.5837C14.3605 13.5837 14 13.9442 14 14.3889L14 15.6111C14 16.0558 14.3605 16.4163 14.8052 16.4163H16.5837V18.1948C16.5837 18.6395 16.9442 19 17.3889 19H18.6111C19.0558 19 19.4163 18.6395 19.4163 18.1948V16.4163H21.1948C21.6395 16.4163 22 16.0558 22 15.6111V14.3889C22 13.9442 21.6395 13.5837 21.1948 13.5837H19.4163V11.8052Z",
    fill: "#8D7DFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_1077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineInpatientIcon);
export default __webpack_public_path__ + "static/media/timeline-inpatient-icon.8ce5d7fcf7e89130c922b0e950462cfd.svg";
export { ForwardRef as ReactComponent };